import api from '@/api_alv'
import { router } from '@/router.js'
import i18n from '@/assets/i18n/i18n'

const DIR = 'az/societies'

// Module-level in-flight promise so concurrent callers share one request
let societiesWhereDirectMemberInFlight = null

const state = {
    societies: [],
    societiesWhereDirectMember: [],
    societiesWhereDirectMemberLoaded: false,
    selectedAzSocieties: [],
    azSocietiesSearch: "",
    isAllSelectedAzSocieties: false,
    expandedAzSocieties: [],
    // Details
    azSocietiesDetails: {},
}

const getters = {
    getAzSocieties(state)                       { return state.societies },
    getSelectedAzSocieties(state)               { return state.selectedAzSocieties },
    getAzSocietiesSearch(state)                 { return state.azSocietiesSearch },
    getIsAllSelectedAzSocieties(state)          { return state.isAllSelectedAzSocieties },
    getExpandedAzSocieties(state)               { return state.expandedAzSocieties },
    getAzSocietiesWhereDirectMember(state)      { return state.societiesWhereDirectMember },
    // Details
    getAzSocietiesDetails(state)                { return state.azSocietiesDetails },
    getAzSocietiesDetailsAlvId(state)           { return state.azSocietiesDetails.alvId },
    getAzSocietiesDetailsName(state)            { return state.azSocietiesDetails.name },
    getAzSocietiesDetailsAddressRowOne(state)   { return state.azSocietiesDetails.addressRow1 },
    getAzSocietiesDetailsZip(state)             { return state.azSocietiesDetails.zip },
    getAzSocietiesDetailsCity(state)            { return state.azSocietiesDetails.city },
    getAzSocietiesDetailsCountry(state)         { return state.azSocietiesDetails.country },
    getAzSocietiesDetailsNotes(state)           { return state.azSocietiesDetails.notes },
    getAzSocietiesDetailsCurrency(state)        { return state.azSocietiesDetails.currency },
    getAzSocietiesDetailsMembershipId(state)    { return state.azSocietiesDetails.membershipId },
    getAzSocietiesDetailsVisibility(state)      { return state.azSocietiesDetails.visibility },
}

const mutations = { 
    setAzSocieties:                         (state, societiesFromDB) => { state.societies = societiesFromDB },
    setSelectedAzSocieties:                 (state, selected) => { state.selectedAzSocieties = selected },
    setAzSocietiesSearch:                   (state, search) => { state.azSocietiesSearch = search },
    setIsAllSelectedAzSocieties:            (state, isSelected) => { state.isAllSelectedAzSocieties = isSelected },
    setExpandedAzSocieties:                 (state, item)   => { state.expandedAzSocieties = [item] },
    setAzSocietiesWhereDirectMember:        (state, items)  => { state.societiesWhereDirectMember = items },
    setSocietiesWhereDirectMemberLoaded:    (state, loaded) => { state.societiesWhereDirectMemberLoaded = loaded },
    // Details
    setAzSocietiesDetails:                  (state, item)   => { state.azSocietiesDetails = item },
    setAzSocietiesDetailsName:              (state, item)   => { state.azSocietiesDetails.name = item },
    setAzSocietiesDetailsAddressRowOne:     (state, item)   => { state.azSocietiesDetails.addressRow1 = item },
    setAzSocietiesDetailsZip:               (state, item)   => { state.azSocietiesDetails.zip = item },
    setAzSocietiesDetailsCity:              (state, item)   => { state.azSocietiesDetails.city = item },
    setAzSocietiesDetailsCountry:           (state, item)   => { state.azSocietiesDetails.country = item },
    setAzSocietiesDetailsNotes:             (state, item)   => { state.azSocietiesDetails.notes = item },
    setAzSocietiesDetailsCurrency:          (state, item)   => { state.azSocietiesDetails.currency = item },
    setAzSocietiesDetailsMembershipId:      (state, item)   => { state.azSocietiesDetails.membershipId = item },
    setAzSocietiesDetailsVisibility:        (state, item)   => { state.azSocietiesDetails.visibility = item },
}

const actions = {
// FETCH societies
    async fetchAzSocieties({ commit, getters }) {  
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            'search' : getters.getAzSocietiesSearch
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)   
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setAzSocieties', [])
        } else {
            commit('setAzSocieties', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

    // Fetch Details for a specific Society     
    async fetchAzSocietiesDetails({ commit }, alvId) {
        let values
        let currentPage = router.currentRoute.name
        let response = await api.getDetailsById(DIR, alvId) 
        if(response === undefined || response.length === 0 || response.error === 1) {
            values = {}
        } else {
            let notes = ""
            if(response.notes !== null){
                notes = response.notes
            }
            if(currentPage === "AzSocietiesEdit"){
                notes = notes.replace(/<br\s*[\/]?>/gi, "\n")
            }
            response.notes = notes
            values = response
        }
        commit('setAzSocietiesDetails', values)
        commit('setIsLoading', false)
    },
    // Fetch all societies where user has direct membership
    async fetchAzSocietiesWhereDirectMember({ commit, state }) {
        if (state.societiesWhereDirectMemberLoaded) {
            return state.societiesWhereDirectMember
        }
        if (societiesWhereDirectMemberInFlight) {
            return societiesWhereDirectMemberInFlight
        }

        const alvPlugin = this._vm.$alvPlugin
        societiesWhereDirectMemberInFlight = (async () => {
            commit('setIsLoading', true)
            // check for set filters
            let filterObj = {
                'isMember': true
            }

            // create string of filter params for api call
            let paramsString = alvPlugin.createApiUrlFilterString(filterObj)

            // Get list items from db
            let response = await api.getListData(DIR, '1', paramsString)

            if(response === undefined || response.length === 0 || response.error === 1) {
                commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
                commit('setAzSocietiesWhereDirectMember', [])
            } else {
                commit('setAzSocietiesWhereDirectMember', response)
            }

            commit('setSocietiesWhereDirectMemberLoaded', true)
            commit('setIsLoading', false)
            return state.societiesWhereDirectMember
        })().finally(() => {
            societiesWhereDirectMemberInFlight = null
        })

        return societiesWhereDirectMemberInFlight
    },
    // SAVE
    async saveAzSocietiesForm({ commit, getters, dispatch }) {
        let alvId = getters.getAzSocietiesDetailsAlvId
        let metaData = getters.getAzSocietiesDetails
        let isNew = router.currentRoute.params.alvId == "new"

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)   

        if(response === undefined || response.length === 0 || response.error === 1) { 
            let errorMessages = response.response.errorMsg
            let errorMessageForSnackbar = i18n.t('lang_GENERIC_SNACKBAR_SAVING_NOT_SUCCESSFUL')

            errorMessages.forEach(msg => {
                errorMessageForSnackbar += '<br />' + i18n.t(msg)
            })

            commit('setSnackbar', {
                type: 'error',
                msg: errorMessageForSnackbar
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL')
            })
            
            await dispatch('fetchAzSocietiesDetails', response.response.alvId)
        }
    },
}

export default {
    state, getters, actions, mutations
}